{
  "dashboard": {
    "title": "我的競賽",
    "description": "查看你的報名、團隊與作品進度。",
    "loading": "載入競賽中…",
    "status": "狀態",
    "deadlineNote": "繳交截止日顯示於競賽詳情頁面。",
    "openCompetition": "進入競賽 →",
    "groups": {
      "active": "進行中",
      "completed": "已完成"
    },
    "card": {
      "registrationNeedsUpdate": "報名資料需補填：{{fields}}",
      "deadline": "截止",
      "completeRegistration": "完成報名",
      "setUpTeam": "設定團隊",
      "startSubmission": "開始準備作品",
      "continueSubmission": "繼續準備作品",
      "checkAndSubmit": "檢查並送出作品",
      "correctionRequired": "查看並修正作品",
      "viewReceipt": "查看投稿收據",
      "viewSubmitted": "查看已提交作品",
      "viewResults": "查看結果",
      "enterCompetition": "進入競賽"
    },
    "empty": {
      "title": "還沒有參加任何競賽",
      "description": "探索目前開放中的競賽，完成報名後就會顯示在這裡。",
      "cta": "探索競賽"
    }
  },
  "competition": {
    "loading": "載入競賽中…",
    "unavailable": "無法取得此競賽。",
    "registrationForm": {
      "loading": "載入中…",
      "save": "儲存",
      "saved": "報名表單已儲存。",
      "saveError": "無法儲存報名表單。",
      "saving": "儲存中…",
      "confirmAndRegister": "確認並完成報名",
      "saveChanges": "儲存變更",
      "completedBadge": "已完成",
      "needsUpdate": "需補填",
      "needsUpdateDetail": "尚需補填：{{fields}}",
      "fillIn": "補填報名資料",
      "incomplete": "待完成",
      "lastUpdated": "最後更新：{{date}}",
      "noFormNeeded": "此競賽無需額外報名資料",
      "viewOrEdit": "查看／修改報名資料",
      "cancelEdit": "取消編輯",
      "cardTitle": "報名資料",
      "autosaved": "✓ 已自動儲存 {{time}}",
      "autosavePending": "尚有必填欄位未完成，填寫完成後會自動儲存。",
      "autosaving": "儲存中…",
      "autosaveError": "⚠ 自動儲存失敗",
      "versionConflict": "此報名資料已在其他視窗被更新。",
      "reloadLatest": "重新載入最新資料",
      "deadlinePassed": "報名時間已截止，無法再儲存或修改報名資料。"
    },
    "registrationSuccess": {
      "title": "報名完成",
      "description": "你的報名資料已成功送出。",
      "later": "稍後處理"
    },
    "myTeam": "我的團隊",
    "memberCount": "{{count}} 位成員",
    "manageTeam": "管理團隊",
    "createOrJoinTeam": "建立或加入團隊",
    "setUpTeam": "設定團隊",
    "submission": "作品繳交",
    "deadline": "{{round}}截止日期",
    "notSet": "尚未設定",
    "advanced": {
      "badge": "已入圍決賽",
      "description": "恭喜入圍！請於截止時間前完成決賽提交。"
    },
    "header": {
      "individualEntry": "個人賽",
      "teamEntry": "團隊賽",
      "noTeamYet": "尚未建立團隊",
      "stageLine": "{{type}} · 目前階段：{{stage}}",
      "stage": {
        "registration": "報名資料",
        "team": "團隊設定",
        "submission": "作品繳交",
        "waiting": "等待評審結果",
        "done": "競賽已結束",
        "results": "結果公布"
      }
    },
    "team": {
      "notCreated": "尚未建立或加入團隊",
      "pending": "待完成",
      "notStarted": "尚未開始"
    },
    "submissionState": {
      "notStarted": "尚未開始",
      "viewSubmission": "查看作品",
      "blockedByTeam": "完成團隊設定後開放",
      "blockedByRegistration": "完成報名後開放",
      "notOpenYet": "尚未到作品繳交時間",
      "missed": "作品繳交已截止"
    },
    "progress": {
      "title": "你的競賽進度",
      "registration": "報名",
      "registrationNeedsUpdate": "報名（需補填）",
      "team": "團隊",
      "submission": "作品繳交",
      "judging": "評審",
      "results": "結果",
      "compact": "步驟 {{current}} / {{total}}"
    },
    "details": {
      "title": "參賽資訊"
    },
    "nextStep": {
      "title": "下一步",
      "registrationTask": "完成報名資料",
      "registrationCta": "前往填寫報名資料",
      "teamTask": "建立或加入團隊",
      "submissionTask": "完成{{round}}作品繳交",
      "currentSubmission": "目前作品：{{state}}",
      "deadlineDetail": "截止：{{date}}",
      "continueSubmission": "繼續編輯作品",
      "startSubmission": "開始準備作品",
      "checkAndSubmit": "檢查並送出作品",
      "finalStartSubmission": "開始準備決賽作品",
      "finalContinueSubmission": "繼續準備決賽作品",
      "finalCheckAndSubmit": "檢查並送出決賽作品",
      "notOpenYetTask": "尚未到作品繳交時間",
      "missedTask": "作品繳交已截止",
      "expiredTask": "作品繳交已截止，目前無法正式送出",
      "finalExpiredTask": "決賽作品繳交已截止，目前無法正式送出",
      "waitingTask": "等待評審結果",
      "finalWaitingTask": "等待決賽評審結果",
      "correctionTask": "需要修正作品",
      "correctionCta": "查看並修正作品",
      "resultPublishedTask": "結果已公布",
      "viewResults": "查看結果",
      "done": "本屆競賽已結束，感謝您的參與。"
    },
    "nextMilestone": {
      "title": "下一個里程碑",
      "withRound": "{{round}} · {{milestone}}",
      "daysRemaining": "還有 {{count}} 天"
    },
    "actionPriority": {
      "p0": "急迫",
      "p1": "即將到期",
      "p2": "一般"
    }
  },
  "team": {
    "title": "團隊",
    "loading": "載入團隊中…",
    "subtitle": "管理團隊成員、邀請與參賽資料。",
    "choice": {
      "title": "設定參賽團隊",
      "description": "你需要加入一個符合競賽規則的團隊才能繼續。",
      "createTitle": "建立新團隊",
      "createDescription": "建立自己的團隊並邀請其他成員。",
      "createCta": "建立團隊",
      "joinTitle": "加入既有團隊",
      "joinDescription": "使用隊友傳給你的安全邀請連結加入團隊。",
      "joinCta": "查看加入方式",
      "joinInfoTitle": "如何加入團隊？",
      "joinInfo": "請開啟隊友傳給你的邀請連結。",
      "joinInfoDetail": "系統會先顯示團隊資訊，確認後即可加入。"
    },
    "notices": {
      "created": "團隊已建立。下一步：邀請隊友加入團隊。",
      "saved": "團隊儲存成功。",
      "inviteRevoked": "邀請已撤銷。",
      "memberRemoved": "成員已移除。",
      "leadershipTransferred": "隊長已轉移。",
      "formSaved": "團隊表單儲存成功。",
      "linkCopied": "邀請連結已複製",
      "copyFailed": "無法自動複製邀請連結，請手動複製。"
    },
    "errors": {
      "create": "無法建立團隊。",
      "save": "無法儲存團隊。",
      "load": "無法載入團隊。",
      "createInvite": "無法建立邀請。",
      "resendInvite": "無法重新寄送邀請。",
      "revokeInvite": "無法撤銷邀請。",
      "removeMember": "無法移除成員。",
      "transferLeadership": "無法轉移隊長。",
      "saveForm": "無法儲存團隊表單。"
    },
    "create": {
      "title": "建立團隊",
      "creating": "建立團隊中…",
      "submit": "建立團隊"
    },
    "fields": {
      "name": "團隊名稱",
      "category": "類別",
      "selectPlaceholder": "請選擇…"
    },
    "details": {
      "title": "團隊詳情",
      "saving": "儲存團隊中…",
      "save": "儲存團隊",
      "leaderOnly": "僅隊長可編輯團隊詳情。"
    },
    "members": {
      "title": "成員",
      "memberCount": "{{count}} 位成員",
      "removing": "移除中…",
      "remove": "移除",
      "removeConfirmTitle": "移除成員？",
      "removeScope": "移除後將立即生效。",
      "removeImpact": "移除後，{{name}} 將不再是此團隊成員。若要再次加入，需要重新接受有效邀請。",
      "removeSuccess": "已移除 {{name}}。",
      "inviteTeammates": "邀請隊友一起加入這個團隊。",
      "transferLeadership": "轉移隊長",
      "selectMember": "請選擇學生成員…",
      "reason": "原因",
      "transferring": "轉移中…",
      "transferSubmit": "轉移隊長",
      "transferConfirmTitle": "轉移隊長給 {{name}}？",
      "transferScope": "轉移後將立即生效。",
      "transferImpact": "完成後 {{name}} 將成為隊長，您將成為一般成員。",
      "transferSuccess": "隊長已轉移給 {{name}}。"
    },
    "results": {
      "title": "我的結果",
      "loading": "載入結果中…",
      "private": "主辦方尚未開放查看結果，如有需要請洽主辦方。",
      "empty": "目前尚無已公布的結果。",
      "publishedAt": "公布時間：{{time}}",
      "finalScore": "總分：{{score}}",
      "rank": "名次：第 {{rank}} 名",
      "awardTier": "獎項：{{tier}}",
      "excluded": "未達評分門檻，未列入本次結果排名。",
      "awardTiers": {
        "first": "第一名",
        "second": "第二名",
        "third": "第三名",
        "honorable": "佳作",
        "vacant": "從缺"
      },
      "breakdown": "評審平均 {{judge}}，工作人員輸入調整 {{manual}}",
      "manualItem": {
        "add": "{{name}}：加 {{value}} 分",
        "deduct": "{{name}}：扣 {{value}} 分"
      }
    },
    "invitations": {
      "title": "邀請隊友",
      "description": "透過 Email 邀請隊友，或分享邀請連結。",
      "emailLabel": "Email",
      "emailPlaceholder": "teammate@example.com",
      "sendEmailInvite": "寄送邀請",
      "sendingEmailInvite": "寄送邀請中…",
      "emailSentHeading": "邀請已寄送至 {{email}}",
      "resend": "重新寄送",
      "orDivider": "或",
      "shareLinkHeading": "分享邀請連結",
      "creating": "建立邀請連結中…",
      "createOneTime": "＋ 建立邀請連結",
      "createAnother": "＋ 建立另一個邀請連結",
      "revoke": "撤銷邀請",
      "currentHeading": "邀請連結有效",
      "linkLabel": "邀請連結",
      "noneYet": "目前沒有有效的邀請連結。",
      "tokenUnavailable": "此邀請的連結僅在建立當下可複製一次。如需重新分享，請撤銷後建立新的邀請連結。",
      "historyToggle": "邀請紀錄 {{count}}",
      "revokeConfirmTitle": "撤銷這個邀請？",
      "revokeConfirmTarget": "建立於 {{date}} 的邀請連結",
      "revokeConfirmTargetWithUrl": "建立於 {{date}} 的邀請連結（{{url}}）",
      "revokeScope": "僅此邀請連結，不影響團隊其他成員或其他邀請。",
      "revokeImpact": "撤銷後，此連結將無法再用來加入團隊；已加入的成員不受影響。",
      "revokeSuccess": "邀請已撤銷。",
      "copy": "複製邀請連結",
      "copyAria": "複製邀請連結",
      "copied": "✓ 已複製",
      "open": "開啟連結",
      "openAria": "在新分頁開啟邀請連結",
      "createdAt": "建立於 {{date}}",
      "status": {
        "active": "有效",
        "revoked": "已撤銷",
        "expired": "已過期",
        "exhausted": "已用盡"
      },
      "usage": {
        "unused": "尚未使用",
        "used": "已使用 {{count}}/{{max}} 次",
        "unlimited": "已使用 {{count}} 次"
      },
      "expiresIn": {
        "days": "{{count}} 天後到期",
        "today": "今天到期",
        "expired": "已過期"
      }
    },
    "form": {
      "title": "團隊參賽資料",
      "loading": "載入團隊表單中…",
      "none": "此競賽不需要額外團隊資料。",
      "formLabel": "表單",
      "loadingFields": "載入表單欄位中…",
      "save": "儲存團隊表單"
    },
    "currentMemberRole": "參賽者角色：{{role}}"
  },
  "submission": {
    "title": "作品繳交",
    "loading": "載入繳交資料中…",
    "teamRequired": "您需要先建立團隊才能開始繳交作品。",
    "createTeam": "建立或加入團隊",
    "noForm": "此競賽尚未設定作品繳交表單。",
    "rounds": {
      "tablist": "賽程輪次"
    },
    "start": {
      "title": "開始繳交",
      "description": "您尚未開始此競賽的作品繳交。",
      "button": "開始繳交",
      "starting": "建立中…"
    },
    "status": {
      "label": "狀態",
      "submittedAt": "送出時間",
      "notSubmitted": "尚未送出",
      "readyNotSubmitted": "已準備，尚未正式送出"
    },
    "waiting": {
      "nothingToDo": "目前沒有需要立即處理的事項。"
    },
    "locked": {
      "submitted": "此作品已送出，無法再編輯。",
      "locked": "此作品已鎖定，無法再編輯。",
      "withdrawn": "此作品已撤回。",
      "disqualified": "此作品已被取消資格。"
    },
    "success": {
      "title": "作品已正式送出",
      "description": "正式送出後系統已保存本次版本。",
      "submittedAtLabel": "送出時間",
      "receiptLabel": "投稿收據",
      "viewReceipt": "查看投稿收據",
      "nextStepLabel": "下一步",
      "nextStepTask": "等待評審結果"
    },
    "draftCreated": {
      "title": "已建立作品草稿",
      "description": "你可以隨時回來繼續準備，正式送出前仍可修改。",
      "cta": "繼續準備作品"
    },
    "correctionRequired": {
      "title": "需要修正作品",
      "description": "主辦方已要求你補充或修正內容，請檢查並修正後重新送出。",
      "reasonLabel": "原因："
    },
    "resultPublished": {
      "title": "結果已公布",
      "cta": "查看結果"
    },
    "receipt": {
      "title": "投稿收據",
      "loading": "載入收據中…",
      "empty": "尚無收據。",
      "id": "收據編號",
      "version": "版本",
      "submittedAt": "送出時間",
      "timezone": "時區",
      "files": "檔案清單",
      "noFiles": "此版本未附加檔案。",
      "status": {
        "active": "有效",
        "withdrawn": "已撤回",
        "disqualified": "已取消資格"
      }
    },
    "form": {
      "title": "填寫內容",
      "loadingFields": "載入表單欄位中…",
      "save": "儲存草稿"
    },
    "actions": {
      "title": "送出作品",
      "markReadyDescription": "將草稿標記為就緒後，即可送出作為最終作品。狀態為草稿或就緒時仍可編輯。",
      "markReady": "標記為就緒",
      "backToDraft": "退回草稿",
      "submit": "送出最終作品",
      "submitting": "送出中…",
      "submitDialogTitle": "送出最終作品",
      "submitDialogScope": "僅影響此作品（第 {{round}} 輪，截止 {{deadline}}）。",
      "submitDialogImpact": "正式送出後將建立不可變的最終版本，作品狀態將鎖定為已送出，無法自行再編輯。若主辦方認為需要修正，可依既有補正流程將作品退回，您會在此頁看到補正說明。",
      "submitDialogSuccess": "作品已送出。",
      "checkAndSubmit": "檢查並送出作品",
      "confirmSubmit": "確認正式送出",
      "returnToReview": "返回檢查",
      "uploadPending": "檔案仍在處理中，請稍候再試。"
    },
    "notices": {
      "saved": "草稿已儲存。"
    },
    "errors": {
      "load": "無法載入作品繳交資料。",
      "create": "無法開始繳交。",
      "save": "無法儲存草稿。",
      "status": "無法更新狀態。",
      "submit": "無法送出作品。"
    },
    "workspace": {
      "completion": "完成度：{{complete}} / {{total}} 個必填項目",
      "required": "必填",
      "optional": "選填",
      "edit": "編輯",
      "collapse": "收合",
      "collapseField": "收合 {{label}}",
      "empty": "（尚未填寫）",
      "status": {
        "complete": "已完成",
        "incomplete": "待完成",
        "uploading": "上傳中",
        "optional_empty": "選填未填",
        "failed": "上傳失敗，請重新上傳"
      }
    },
    "preflight": {
      "title": "提交前檢查",
      "requiredHeading": "必填項目",
      "optionalHeading": "選填項目",
      "itemLine": "{{label}}：{{state}}",
      "notComplete": "尚未完成",
      "optionalNotProvided": "{{label}} 未提供",
      "goToField": "前往補充",
      "competitionLabel": "競賽",
      "teamLabel": "團隊",
      "roundLabel": "輪次",
      "deadlineLabel": "截止時間",
      "notSet": "尚未設定",
      "backToEdit": "返回修改",
      "confirm": "正式送出作品"
    },
    "teamDisqualified": "您已被取消資格，無法再開始或修改任何輪次的繳交。請與主辦方聯絡。"
  },
  "eligibility": {
    "title": "學生資格驗證",
    "subtitle": "上傳在學證明，並確認你的資格驗證狀態。",
    "loading": "載入資格驗證資料中…",
    "unavailable": "目前無法載入資格驗證資料。",
    "notRequired": "此競賽不要求學生資格驗證。",
    "backToWorkspace": "返回競賽工作區",
    "status": {
      "missing": "尚未上傳",
      "pending": "審核中",
      "verified": "已驗證",
      "rejected": "已退回",
      "expired": "已過期"
    },
    "ownStatus": {
      "title": "我的資格驗證狀態",
      "pendingHint": "已收到你的資格證明，正在等待審核。此狀態不影響已完成的競賽報名。",
      "rejectionReasonTitle": "退回原因",
      "expiredHint": "先前的在學證明已過期，請重新上傳。",
      "uploadedAt": "上傳時間：{{date}}",
      "download": "下載檢視",
      "downloadError": "無法產生下載連結，請稍後再試。"
    },
    "upload": {
      "title": "上傳在學證明",
      "replaceTitle": "重新上傳在學證明",
      "proofType": "證明類型",
      "proofTypeOptions": {
        "enrollment_certificate": "在學證明書",
        "student_id": "學生證",
        "other_approved": "其他經核准之證明"
      },
      "schoolName": "學校名稱",
      "departmentName": "系所（選填）",
      "studentNumber": "學號（選填）",
      "selectFile": "選擇檔案",
      "replace": "重新上傳",
      "replaceWarning": "目前的資格證明正在審核中。上傳新文件後，將以新文件重新進入審核流程。",
      "cancelReplace": "取消",
      "prefillNotice": "已沿用目前的資格資料，你可以只更換文件，也可以一併修改。",
      "uploading": "上傳中…",
      "finalizing": "處理中…",
      "cancel": "取消上傳",
      "allowedTypes": "支援 {{extensions}}，單一檔案最大 10 MB。",
      "errors": {
        "fileTypeNotAllowed": "不允許此檔案類型。",
        "tooLarge": "檔案大小不可超過 10 MB。",
        "empty": "檔案內容為空，請重新選擇有效的資格證明文件。",
        "extensionNotAllowed": "僅允許以下檔案類型：{{extensions}}",
        "generic": "上傳失敗，請再試一次。",
        "genericWithDetail": "上傳失敗：{{detail}}"
      }
    },
    "teamSummary": {
      "title": "團隊資格驗證完成度",
      "submittedProgress": "已提交資格證明 {{submitted}} / {{required}}",
      "approvedProgress": "已通過資格驗證 {{approved}} / {{required}}",
      "allApproved": "✓ 所有必要成員皆已完成資格驗證。",
      "you": "你",
      "leader": "隊長",
      "notRequired": "無需驗證"
    }
  },
  "result": {
    "title": "查看結果",
    "loading": "載入中…",
    "teamRequired": "您需要先建立團隊才能查看結果。",
    "notAdvanced": "本輪未晉級下一輪，感謝您的參與。",
    "errors": {
      "load": "無法載入資料，請稍後再試。"
    },
    "cta": {
      "prepareFinal": "開始準備決賽作品",
      "backToWorkspace": "返回競賽總覽"
    },
    "disqualified": {
      "title": "您的隊伍已被取消資格",
      "body": "您已被取消資格，無法再提交或修改作品，成績也不會列入評比。如有疑問，請與主辦方聯絡。"
    }
  },
  "workspace": {
    "nav": "參賽任務導覽",
    "openNav": "開啟參賽任務選單",
    "overview": "總覽",
    "groups": {
      "tasks": "參賽任務",
      "results": "結果",
      "information": "資訊"
    },
    "items": {
      "eligibility": "學生資格驗證",
      "team": "我的團隊",
      "submission": "我的作品",
      "result": "我的結果",
      "information": "競賽資訊"
    },
    "identity": {
      "individual": "參賽者",
      "withTeam": "參賽者 · {{team}} · {{role}}"
    },
    "accessDenied": {
      "title": "無法進入這場競賽的參賽者工作區",
      "description": "你目前無法以此角色進入這場競賽。",
      "back": "返回我的競賽"
    }
  },
  "information": {
    "title": "競賽資訊",
    "loading": "載入競賽資訊中…",
    "unavailable": "目前無法載入競賽資訊。",
    "schedule": {
      "title": "賽程與里程碑",
      "empty": "尚未公告賽程。"
    },
    "announcements": {
      "title": "公告"
    },
    "rules": {
      "title": "規則與資源"
    }
  }
}
